/* Refonte V4 mobile — zone plp : tiroirs (filtres, tri, ajout rapide), pastilles des cartes,
   compte « Voir N résultats », raccourci flottant, recherche instantanée, puces de catégories.
   Chargé sur toutes les pages (les cartes produit apparaissent aussi sur l'accueil et la fiche). */
(function () {
  'use strict';
  var d = document, root = d.documentElement;
  var desk = window.matchMedia('(min-width: 1024px)');
  var cfg = {};
  try { cfg = JSON.parse((d.getElementById('v4p-qa-config') || {}).textContent || '{}'); } catch (e) { cfg = {}; }
  var T = cfg.t || {};

  /* ---------- Utilitaires ---------- */
  function money(cents) {
    var fmt = cfg.money || '€{{amount_with_comma_separator}}';
    var n = (cents / 100);
    function sep(num, dec, th, ds) {
      var p = num.toFixed(dec).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return dec ? p[0] + ds + p[1] : p[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount': return sep(n, 2, ',', '.');
        case 'amount_no_decimals': return sep(n, 0, ',', '.');
        case 'amount_with_comma_separator': return sep(n, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return sep(n, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return sep(n, 2, "'", '.');
        case 'amount_with_space_separator': return sep(n, 2, ' ', ',');
        default: return sep(n, 2, ',', '.');
      }
    });
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function bfLive() { return root.getAttribute('data-bf') === 'live'; }
  function sized(src, w) { if (!src) return ''; if (src.indexOf('//') === 0) src = 'https:' + src; return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  var live = d.createElement('div');
  live.className = 'v4p-sr'; live.setAttribute('aria-live', 'polite');
  function say(msg) { live.textContent = ''; setTimeout(function () { live.textContent = msg; }, 30); }
  if (d.body) d.body.appendChild(live); else d.addEventListener('DOMContentLoaded', function () { d.body.appendChild(live); });

  /* ---------- Tiroirs (bas sur mobile) ---------- */
  var current = null, opener = null;
  function isSidebar(el) { return el.classList.contains('v4p-drawer--filters') && desk.matches; }
  function openDrawer(el, from) {
    if (!el) return;
    if (isSidebar(el)) { var f = el.querySelector('input, button'); if (f) f.focus(); return; }
    if (current && current !== el) closeDrawer(true);
    opener = from || d.activeElement;
    current = el;
    el.classList.add('is-open');
    root.classList.add('v4p-lock');
    // Focus sur le panneau (pas d'anneau sur la croix à l'ouverture) ; Tab mène ensuite aux commandes
    setTimeout(function () { var pn = el.querySelector('.v4p-drawer__panel'); if (pn) { pn.tabIndex = -1; pn.focus({ preventScroll: true }); } }, 60);
  }
  function closeDrawer(silent) {
    if (!current) return;
    var el = current; current = null;
    el.classList.remove('is-open');
    el.querySelector('.v4p-drawer__panel').style.transform = '';
    root.classList.remove('v4p-lock');
    if (!silent && opener && opener.focus) opener.focus({ preventScroll: true });
  }
  d.addEventListener('click', function (e) {
    var o = e.target.closest('[data-v4p-open]');
    if (o) { e.preventDefault(); openDrawer(d.getElementById(o.getAttribute('data-v4p-open')), o); return; }
    if (e.target.closest('[data-v4p-close]')) { e.preventDefault(); closeDrawer(); }
  });
  d.addEventListener('keydown', function (e) {
    if (!current) return;
    if (e.key === 'Escape') { closeDrawer(); return; }
    if (e.key !== 'Tab') return;
    var f = [].filter.call(current.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]):not([hidden]), select'), function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  // Glisser vers le bas pour fermer (poignée / en-tête)
  var drag = null;
  d.addEventListener('pointerdown', function (e) {
    if (!current || desk.matches) return;
    var h = e.target.closest('.v4p-drawer__grip, .v4p-drawer__head, .v4p-qa__head');
    if (!h || !current.contains(h) || e.target.closest('button, a, input')) return;
    drag = { y: e.clientY, panel: current.querySelector('.v4p-drawer__panel'), dy: 0 };
    drag.panel.style.transition = 'none';
  });
  d.addEventListener('pointermove', function (e) {
    if (!drag) return;
    drag.dy = Math.max(0, e.clientY - drag.y);
    drag.panel.style.transform = 'translateY(' + drag.dy + 'px)';
  });
  function endDrag() {
    if (!drag) return;
    var p = drag.panel, dy = drag.dy; drag = null;
    p.style.transition = '';
    if (dy > 90) closeDrawer(); else p.style.transform = '';
  }
  d.addEventListener('pointerup', endDrag);
  d.addEventListener('pointercancel', endDrag);

  /* ---------- Liste produits : filtres, tri, compte ---------- */
  function initPlp() {
    var plp = d.querySelector('[data-v4p-plp]');
    if (!plp) return;
    var sid = plp.getAttribute('data-section-id');
    var base = plp.getAttribute('data-collection-url');
    var form = plp.querySelector('[data-v4p-filter-form]');
    var apply = plp.querySelector('[data-v4p-apply]');
    var filters = d.getElementById('v4p-filters');

    function syncSidebarRole() {
      if (!filters) return;
      if (desk.matches) { filters.removeAttribute('role'); filters.removeAttribute('aria-modal'); }
      else { filters.setAttribute('role', 'dialog'); filters.setAttribute('aria-modal', 'true'); }
    }
    syncSidebarRole();
    if (desk.addEventListener) desk.addEventListener('change', syncSidebarRole);

    function buildUrl() {
      var p = new URLSearchParams();
      if (form) new FormData(form).forEach(function (v, k) { if (String(v).trim() !== '') p.append(k, v); });
      var q = p.toString();
      return base + (q ? '?' + q : '');
    }
    var seq = 0;
    function label(n) {
      if (!apply) return;
      apply.textContent = n === 0 ? apply.getAttribute('data-zero') : n === 1 ? apply.getAttribute('data-one') : apply.getAttribute('data-other').replace('__n__', n);
      apply.disabled = n === 0;
    }
    function refreshCount() {
      if (!apply) return;
      var my = ++seq, url = buildUrl();
      apply.classList.add('is-busy'); apply.setAttribute('aria-busy', 'true');
      fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sid), { credentials: 'same-origin' })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          if (my !== seq) return;
          var m = html.match(/data-v4p-total="(\d+)"/);
          if (m) label(+m[1]);
        })
        .catch(function () {})
        .then(function () { if (my === seq) { apply.classList.remove('is-busy'); apply.removeAttribute('aria-busy'); } });
    }
    if (form) {
      form.addEventListener('change', function (e) {
        var t = e.target;
        if (t.matches('[data-family-toggle]')) {
          var fam = t.closest('[data-color-family]');
          if (fam) fam.querySelectorAll('input[data-shade]').forEach(function (cb) { cb.checked = t.checked; });
        }
        if (desk.matches) { window.location.href = buildUrl(); return; }
        refreshCount();
      });
      form.addEventListener('submit', function (e) { e.preventDefault(); window.location.href = buildUrl(); });
    }
    if (apply) apply.addEventListener('click', function () { window.location.href = buildUrl(); });

    plp.addEventListener('click', function (e) {
      var un = e.target.closest('[data-v4p-unfam]');
      if (un && form) {
        var fam = form.querySelector('[data-fam="' + un.getAttribute('data-v4p-unfam') + '"]');
        if (fam) fam.querySelectorAll('input').forEach(function (cb) { cb.checked = false; });
        window.location.href = buildUrl();
        return;
      }
      var s = e.target.closest('[data-v4p-sort]');
      if (s) { goSort(s.getAttribute('data-v4p-sort')); }
    });
    function goSort(v) {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', v);
      u.searchParams.delete('page');
      u.searchParams.delete('section_id');
      window.location.href = u.toString();
    }
    plp.querySelectorAll('[data-collection-sort]').forEach(function (sel) {
      sel.addEventListener('change', function () { goSort(sel.value); });
    });

    // Intro repliée
    var intro = plp.querySelector('[data-v4p-intro]'), more = plp.querySelector('[data-v4p-intro-more]');
    if (intro && more) {
      if (intro.scrollHeight > intro.clientHeight + 4) more.hidden = false;
      more.addEventListener('click', function () { intro.classList.add('is-open'); more.hidden = true; });
    }

    // Raccourci flottant : visible quand la barre de commandes est passée, masqué en fin de liste
    var bar = plp.querySelector('[data-v4p-bar]'), fab = plp.querySelector('[data-v4p-fab]');
    if (bar && fab) {
      var ticking = false, lastY = window.scrollY, goingDown = false;
      var onScroll = function () {
        ticking = false;
        if (desk.matches) return;
        // Comme l'en-tête : il s'efface quand on descend (il ne couvre pas les « + » de la dernière rangée), revient quand on remonte
        var y = window.scrollY;
        if (Math.abs(y - lastY) > 6) { goingDown = y > lastY; lastY = y; }
        var b = bar.getBoundingClientRect(), r = plp.getBoundingClientRect();
        var on = b.bottom < 0 && r.bottom > window.innerHeight * 0.75 && !current && !goingDown;
        if (on !== fab.classList.contains('is-on')) {
          fab.classList.toggle('is-on', on);
          fab.setAttribute('aria-hidden', on ? 'false' : 'true');
          fab.querySelectorAll('button').forEach(function (x) { x.tabIndex = on ? 0 : -1; });
        }
      };
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
      onScroll();
    }
  }

  /* ---------- Puces défilantes : la courante est amenée en vue ---------- */
  function initScrollers() {
    d.querySelectorAll('.v4p-cats__track').forEach(function (tr) {
      var on = tr.querySelector('.is-on');
      if (!on || tr.scrollWidth <= tr.clientWidth) return;
      // La puce courante est amenée en vue avec la précédente entière à sa gauche (pas de puce coupée au bord)
      var gut = parseFloat(getComputedStyle(tr).paddingLeft) || 20;
      var prev = on.previousElementSibling || on;
      var x = prev.getBoundingClientRect().left - tr.getBoundingClientRect().left + tr.scrollLeft - gut;
      tr.scrollLeft = Math.max(0, x);
      tr.classList.toggle('is-scrolled', tr.scrollLeft > 2);
      tr.addEventListener('scroll', function () { tr.classList.toggle('is-scrolled', tr.scrollLeft > 2); }, { passive: true });
    });
  }

  /* ---------- Cartes : pastilles de coloris ---------- */
  d.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-v4p-swatch]');
    if (!sw) return;
    e.preventDefault(); e.stopPropagation();
    var card = sw.closest('[data-v4p-card]');
    if (!card) return;
    var img = card.querySelector('[data-v4p-card-img]');
    var src = sw.getAttribute('data-src');
    if (img && src && img.getAttribute('src') !== src) {
      img.classList.add('is-swapping');
      img.onload = function () { img.classList.remove('is-swapping'); };
      img.srcset = sw.getAttribute('data-srcset') || '';
      img.src = src;
      var alt = card.querySelector('[data-v4p-card-alt]');
      if (alt) alt.remove();
    }
    var href = sw.getAttribute('data-href');
    if (href) {
      card.querySelectorAll('[data-v4p-card-link], [data-v4p-card-more]').forEach(function (a) { a.href = href; });
    }
    card.setAttribute('data-color', sw.getAttribute('data-color'));
    if (sw.getAttribute('data-variant')) card.setAttribute('data-variant', sw.getAttribute('data-variant'));
    card.querySelectorAll('[data-v4p-swatch]').forEach(function (x) {
      var on = x === sw; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  });

  /* ---------- Ajout rapide ---------- */
  var cache = {};
  var qa = { el: null, p: null, card: null, sel: {}, colorIdx: -1 };
  function getProduct(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch((cfg.root || '/').replace(/\/?$/, '/') + 'products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('product'); return r.json(); })
      .then(function (p) { cache[handle] = p; return p; });
  }
  function addToCart(id) {
    // URL racine : le panier glissant de MoonBundle écoute /cart/add
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j && (j.description || j.message) || 'add'); return j; }); });
  }
  function afterAdd(data) {
    d.dispatchEvent(new CustomEvent('cart:added', { detail: data }));
    d.dispatchEvent(new CustomEvent('cart:updated'));
    say(T.added || '');
    if (window.cartDrawer && typeof window.cartDrawer.refresh === 'function') {
      Promise.resolve(window.cartDrawer.refresh()).then(function () { if (window.cartDrawer.open) window.cartDrawer.open(); });
    }
  }
  function isColorOpt(o) { return (cfg.colorNames || ['Color', 'Colour', 'Couleur']).indexOf(o.name) > -1 || /colou?r|couleur|farbe|colore/i.test(o.name); }

  d.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-v4p-qa-open]');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    var card = btn.closest('[data-v4p-card]');
    if (!card) return;
    var direct = card.hasAttribute('data-direct') && !btn.hasAttribute('data-v4p-qa-sheet') && card.getAttribute('data-variant');
    if (direct) {
      if (btn.classList.contains('is-busy')) return;
      btn.classList.add('is-busy');
      var ic = btn.querySelector('.material-symbols-outlined');
      if (ic) ic.textContent = 'progress_activity';
      addToCart(card.getAttribute('data-variant')).then(function (data) {
        btn.classList.remove('is-busy'); btn.classList.add('is-done');
        if (ic) ic.textContent = 'check';
        afterAdd(data);
        setTimeout(function () { btn.classList.remove('is-done'); if (ic) ic.textContent = 'add'; }, 1800);
      }).catch(function () {
        btn.classList.remove('is-busy'); btn.classList.add('is-error');
        if (ic) ic.textContent = 'error';
        say(T.error || '');
        setTimeout(function () { btn.classList.remove('is-error'); if (ic) ic.textContent = 'add'; }, 2200);
      });
      return;
    }
    openQa(card, btn);
  });

  function openQa(card, btn) {
    qa.el = d.getElementById('v4p-qa');
    if (!qa.el) return;
    qa.card = card;
    qa.p = null;
    qa.el.classList.add('is-loading');
    qa.el.classList.remove('is-failed');
    qa.el.querySelector('[data-v4p-qa-err]').hidden = true;
    // Repart d'un tiroir propre (pas de reste du produit précédent pendant le chargement)
    var t0 = card.querySelector('.rs-card__title, .v4p-plp__title');
    qa.el.querySelector('[data-v4p-qa-title]').textContent = t0 ? t0.textContent : '';
    qa.el.querySelector('[data-v4p-qa-price]').innerHTML = '';
    qa.el.querySelector('[data-v4p-qa-night]').hidden = true;
    qa.el.querySelector('[data-v4p-qa-opts]').innerHTML = '';
    qa.guide = false;
    var g0 = qa.el.querySelector('[data-v4p-qa-guide]'); if (g0) g0.hidden = true;
    var im0 = card.querySelector('[data-v4p-card-img], .rs-card__img'), qimg = qa.el.querySelector('[data-v4p-qa-img]');
    if (im0 && im0.currentSrc) qimg.src = im0.currentSrc; else qimg.removeAttribute('src');
    var cta0 = qa.el.querySelector('[data-v4p-qa-add]');
    cta0.disabled = true; cta0.textContent = T.choose || '';
    var lk = card.querySelector('[data-v4p-card-link]') || card.querySelector('a[href*="/products/"]');
    qa.el.querySelector('[data-v4p-qa-link]').href = lk ? lk.href : '#';
    openDrawer(qa.el, btn);
    getProduct(card.getAttribute('data-handle')).then(function (p) {
      qa.p = p; qa.sel = {};
      qa.colorIdx = -1;
      p.options.forEach(function (o, i) {
        if (isColorOpt(o)) { qa.colorIdx = i; qa.sel[i] = card.getAttribute('data-color') || null; }
        if (o.values.length === 1) qa.sel[i] = o.values[0];
      });
      if (qa.colorIdx > -1 && p.options[qa.colorIdx].values.indexOf(qa.sel[qa.colorIdx]) < 0) {
        var fv = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
        qa.sel[qa.colorIdx] = fv.options[qa.colorIdx];
      }
      // Pas d'autre option qu'une couleur : la variante est déjà choisie
      renderQa();
      qa.el.classList.remove('is-loading');
    }).catch(function () {
      // Produit illisible (réseau) : on propose la fiche, jamais un tiroir vide
      qa.el.classList.remove('is-loading');
      qa.el.classList.add('is-failed');
      var er = qa.el.querySelector('[data-v4p-qa-err]'); er.textContent = T.error || ''; er.hidden = false;
      var cta = qa.el.querySelector('[data-v4p-qa-add]');
      cta.disabled = false; cta.textContent = T.view || '';
    });
  }
  function findVariant() {
    var p = qa.p;
    for (var i = 0; i < p.options.length; i++) if (!qa.sel[i]) return null;
    return p.variants.filter(function (v) { return v.options.every(function (o, i) { return o === qa.sel[i]; }); })[0] || null;
  }
  function availableWith(i, val) {
    return qa.p.variants.some(function (v) {
      return v.options[i] === val && v.available && (qa.colorIdx < 0 || !qa.sel[qa.colorIdx] || v.options[qa.colorIdx] === qa.sel[qa.colorIdx]);
    });
  }
  function colorImage(color) {
    var p = qa.p, v = p.variants.filter(function (x) { return x.options[qa.colorIdx] === color && x.featured_image; })[0];
    if (v) return v.featured_image.src;
    var m = (p.media || []).filter(function (x) { return x.alt && x.alt.split(' :: ')[0].trim() === color; })[0];
    return m ? m.src : (p.featured_image || '');
  }
  function renderQa() {
    var p = qa.p, el = qa.el, card = qa.card;
    var v = findVariant();
    var base = v || p.variants.filter(function (x) { return qa.colorIdx < 0 || x.options[qa.colorIdx] === qa.sel[qa.colorIdx]; })[0] || p.variants[0];
    el.querySelector('[data-v4p-qa-title]').textContent = p.title.split(' — ')[0];
    var img = el.querySelector('[data-v4p-qa-img]');
    var isrc = qa.colorIdx > -1 ? colorImage(qa.sel[qa.colorIdx]) : (base.featured_image ? base.featured_image.src : p.featured_image);
    if (isrc) { img.src = sized(isrc, 240); img.alt = p.title; }
    var pct = +(card.getAttribute('data-bf-pct') || 0);
    var price = base.price, bf = pct > 0 && bfLive();
    var shown = bf ? Math.floor((price * (100 - pct) + 50) / 100) : price;
    var html = '<strong>' + esc(money(shown)) + '</strong>';
    if (bf) html += ' <s>' + esc(money(price)) + '</s>';
    else if (base.compare_at_price && base.compare_at_price > price) html += ' <s>' + esc(money(base.compare_at_price)) + '</s>';
    el.querySelector('[data-v4p-qa-price]').innerHTML = html;
    var night = el.querySelector('[data-v4p-qa-night]');
    if (shown >= 4000 && T.night) { night.textContent = T.night.replace('__p__', money(Math.floor((shown + 182) / 365))); night.hidden = false; }
    else night.hidden = true;

    var out = '', guideOk = false, guideEl = el.querySelector('[data-v4p-qa-guide]');
    p.options.forEach(function (o, i) {
      if (o.values.length < 2) return;
      var isC = i === qa.colorIdx;
      // Vêtements (tailles XS–XL) : lien « Guide des tailles » à côté du titre
      var wear = !isC && guideEl && T.guide && o.values.every(function (x) { return /^(XXS|XS|S|M|L|XL|XXL)$/i.test(String(x).trim()); });
      if (wear) guideOk = true;
      // Groupe nommé (role=group) plutôt qu'un fieldset : le titre et « Guide des tailles » partagent une ligne flex
      out += '<div class="v4p-qa__opt" role="group" aria-labelledby="v4p-qa-l' + i + '"><div class="v4p-qa__opthead"><p class="v4p-qa__optlabel" id="v4p-qa-l' + i + '">' + esc(isC ? T.color : (/size|taille|talla|taglia|größe/i.test(o.name) ? T.size : o.name)) +
        (qa.sel[i] ? ' <span>' + esc(qa.sel[i]) + '</span>' : '') + '</p>' +
        (wear ? '<button type="button" class="v4p-qa__guidebtn" data-v4p-qa-guide-toggle aria-controls="v4p-qa-guide" aria-expanded="' + (qa.guide ? 'true' : 'false') + '"><span class="material-symbols-outlined" aria-hidden="true">straighten</span>' + esc(T.guide) + '</button>' : '') + '</div>' +
        '<div class="' + (isC ? 'v4p-qa__sws' : 'v4p-qa__sizes') + '">';
      o.values.forEach(function (val) {
        var on = qa.sel[i] === val;
        var ok = isC ? true : availableWith(i, val);
        if (isC) {
          var bg = (cfg.swatches || {})[val] || '#D9D4CE';
          out += '<button type="button" class="v4p-qa__sw' + (on ? ' is-on' : '') + '" data-i="' + i + '" data-val="' + esc(val) + '" aria-pressed="' + on + '" aria-label="' + esc(val) + '" title="' + esc(val) + '"><span style="background:' + esc(bg) + '"></span></button>';
        } else {
          out += '<button type="button" class="v4p-qa__size' + (on ? ' is-on' : '') + '" data-v4p-qa-size data-i="' + i + '" data-val="' + esc(val) + '" aria-pressed="' + on + '"' + (ok ? '' : ' disabled') + '>' + esc(val) + '</button>';
        }
      });
      out += '</div></div>';
    });
    el.querySelector('[data-v4p-qa-opts]').innerHTML = out;
    if (guideEl) {
      guideEl.hidden = !(guideOk && qa.guide);
      var cur = null;
      p.options.forEach(function (o, i) { if (i !== qa.colorIdx && qa.sel[i]) cur = String(qa.sel[i]).toUpperCase(); });
      guideEl.querySelectorAll('tr[data-size]').forEach(function (tr) { tr.classList.toggle('is-on', tr.getAttribute('data-size') === cur); });
    }

    var cta = el.querySelector('[data-v4p-qa-add]');
    cta.classList.remove('is-done');
    if (!v) { cta.disabled = true; cta.textContent = T.choose || ''; }
    else if (!v.available) { cta.disabled = true; cta.textContent = T.soldOut || ''; }
    else { cta.disabled = false; cta.innerHTML = esc(T.add) + '<span class="v4p-qa__ctaprice">' + esc(money(bf ? Math.floor((v.price * (100 - pct) + 50) / 100) : v.price)) + '</span>'; }
    var link = el.querySelector('[data-v4p-qa-link]');
    link.href = p.url + (v ? '?variant=' + v.id : (base ? '?variant=' + base.id : ''));
  }
  d.addEventListener('click', function (e) {
    if (!qa.el || !qa.el.contains(e.target)) return;
    var gt = e.target.closest('[data-v4p-qa-guide-toggle]');
    if (gt) {
      qa.guide = !qa.guide;
      gt.setAttribute('aria-expanded', qa.guide ? 'true' : 'false');
      var ge = qa.el.querySelector('[data-v4p-qa-guide]');
      if (ge) { ge.hidden = !qa.guide; if (qa.guide) ge.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }
      return;
    }
    var o = e.target.closest('.v4p-qa__sw, .v4p-qa__size');
    if (o && !o.disabled) {
      qa.sel[+o.getAttribute('data-i')] = o.getAttribute('data-val');
      // Taille devenue indisponible dans le nouveau coloris : on la désélectionne
      var v = findVariant();
      if (v && !v.available) p_unsetSize();
      renderQa();
      var again = qa.el.querySelector('[data-i="' + o.getAttribute('data-i') + '"][data-val="' + CSS.escape(o.getAttribute('data-val')) + '"]');
      if (again) again.focus({ preventScroll: true });
      return;
    }
    var add = e.target.closest('[data-v4p-qa-add]');
    if (add && !add.disabled && qa.el.classList.contains('is-failed')) {
      window.location.href = qa.el.querySelector('[data-v4p-qa-link]').href;
      return;
    }
    if (add && !add.disabled && qa.p) {
      var vv = findVariant();
      if (!vv) return;
      add.disabled = true; add.classList.add('is-busy');
      addToCart(vv.id).then(function (data) {
        add.classList.remove('is-busy'); add.classList.add('is-done');
        add.innerHTML = '<span class="material-symbols-outlined" aria-hidden="true">check</span>' + esc(T.added);
        afterAdd(data);
        setTimeout(function () { closeDrawer(true); add.disabled = false; }, 900);
      }).catch(function (err) {
        add.classList.remove('is-busy'); add.disabled = false;
        var er = qa.el.querySelector('[data-v4p-qa-err]'); er.textContent = T.error || String(err.message || ''); er.hidden = false;
      });
    }
  });
  function p_unsetSize() {
    qa.p.options.forEach(function (o, i) { if (i !== qa.colorIdx && o.values.length > 1) qa.sel[i] = null; });
  }

  /* ---------- Recherche instantanée ---------- */
  function initSearch() {
    var box = d.querySelector('[data-v4p-search]');
    if (!box) return;
    var input = box.querySelector('[data-v4p-search-input]');
    var panel = box.querySelector('[data-v4p-suggest]');
    var idle = d.querySelector('[data-v4p-search-idle]');
    var clear = box.querySelector('[data-v4p-search-clear]');
    var initial = input.value;
    var timer, n = 0;
    function toggleClear() { if (clear) clear.hidden = !input.value; }
    toggleClear();
    if (clear) clear.addEventListener('click', function () { input.value = ''; toggleClear(); panel.hidden = true; panel.innerHTML = ''; if (idle) idle.hidden = false; input.focus(); });
    input.addEventListener('input', function () {
      toggleClear();
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2 || q === initial) { panel.hidden = true; panel.innerHTML = ''; return; }
      timer = setTimeout(function () { suggest(q); }, 220);
    });
    function suggest(q) {
      var my = ++n;
      var url = (cfg.root || '/').replace(/\/?$/, '/') + 'search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,query&resources[limit]=6&resources[limit_scope]=each';
      fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (j) {
        if (my !== n) return;
        var res = (j.resources && j.resources.results) || {};
        var html = '';
        var qs = (res.queries || []).slice(0, 4), cols = (res.collections || []).slice(0, 3), prods = (res.products || []).slice(0, 6);
        if (qs.length || cols.length) {
          html += '<div class="v4p-suggest__chips">';
          qs.forEach(function (x) { html += '<a class="v4p-chip" href="' + esc(x.url) + '">' + (x.styled_text || esc(x.text)) + '</a>'; });
          cols.forEach(function (x) { html += '<a class="v4p-chip v4p-chip--col" href="' + esc(x.url) + '">' + esc(x.title) + '</a>'; });
          html += '</div>';
        }
        if (prods.length) {
          html += '<p class="v4p-suggest__label">' + esc(box.getAttribute('data-l-products')) + '</p><ul class="v4p-suggest__list">';
          prods.forEach(function (x) {
            var price = x.price ? money(Math.round(parseFloat(x.price) * 100)) : '';
            html += '<li><a href="' + esc(x.url) + '"><img src="' + esc(sized(x.featured_image && x.featured_image.url || x.image, 160)) + '" alt="" width="56" height="70" loading="lazy"><span><strong>' + esc(x.title) + '</strong><em>' + esc(price) + '</em></span><span class="material-symbols-outlined" aria-hidden="true">north_west</span></a></li>';
          });
          html += '</ul>';
        }
        html += '<a class="v4-btn v4-btn--secondary v4-btn--block v4p-suggest__all" href="' + esc(box.getAttribute('action') + '?q=' + encodeURIComponent(q)) + '">' + esc(box.getAttribute('data-l-all').replace('__q__', q)) + '</a>';
        panel.innerHTML = html;
        panel.hidden = false;
        if (idle) idle.hidden = true;
      }).catch(function () {});
    }
  }

  function boot() { initPlp(); initScrollers(); initSearch(); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
})();
